import { Component, Input, Output, EventEmitter } from "@angular/core";
import { StatusService } from "../../../services/status.service";
import { UsersService } from "../../../services/users.service";
import { BranchService } from "../../../services/branch.service";
import { PrioritiesService } from "../../../services/priorities.service";
import { DepartmentsService } from "../../../services/departaments.service";

type FilterCode =
  | "by.id"
  | "by.title"
  | "by.assigned"
  | "by.branch"
  | "by.department"
  | "by.registered"
  | "by.status"
  | "by.priority"
  | "newest"
  | "active"
  | "archived"
  | "not";

@Component({
  selector: "selected-filters",
  templateUrl: "./selected-filters.component.html",
  styleUrls: ["./selected-filters.component.css"],
})
export class SelectedFiltersComponent {
  @Input() selectedFilters: any[] = [];
  @Output() removeFilter = new EventEmitter<any>();

  constructor(
    private priority: PrioritiesService,
    private department: DepartmentsService,
    private branchService: BranchService,
    private userService: UsersService,
    private statusService: StatusService
  ) {}
  onRemoveFilter(filter: any) {
    this.removeFilter.emit(filter);
  }
  getFilterClass(filter: any): string {
    const iconClassMap: { [key in FilterCode]: string } = {
      "by.id": "selected-filter-tag",
      "by.title": "selected-filter-title",
      "by.assigned": "selected-filter-person",
      "by.branch": "selected-filter-business",
      "by.department": "selected-filter-apartment",
      "by.registered": "selected-filter-how_to_reg",
      "by.status": "selected-filter-check_circle",
      "by.priority": "selected-filter-error_circle",
      newest: "selected-filter-new_releases",
      active: "selected-filter-toggle_on",
      archived: "selected-filter-archive",
      not: "selected-filter-do_disturb_off",
    };

    if (filter.code === "not" && filter.filters?.length) {
      const inner = filter.filters[0];
      return (
        iconClassMap["not"] +
        " " +
        (iconClassMap[inner.code as FilterCode] || "")
      );
    }

    if (filter.code === "match.any" && filter.filters?.length) {
      const type = filter.filters[0].code;
      const sameType = filter.filters.every((f: any) => f.code === type);
      if (sameType && iconClassMap[type as FilterCode]) {
        return iconClassMap[type as FilterCode];
      }
    }

    return iconClassMap[filter.code as FilterCode] || "";
  }

  getFilterIcon(filter: any): string {
    if (filter.code === "not" && filter.filters?.length) {
      return this.getFilterIcon(filter.filters[0]);
    }

    if (filter.code === "match.any" && filter.filters?.length) {
      const type = filter.filters[0].code;

      const sameType = filter.filters.every((f: any) => f.code === type);
      if (!sameType) return "filter_alt";

      switch (type) {
        case "by.registered":
          return "how_to_reg";
        case "by.assigned":
          return "person";
        case "by.branch":
          return "business";
        case "by.department":
          return "apartment";
        case "by.status":
          return "check_circle";
        case "by.priority":
          return "priority_high";
        case "by.id":
          return "tag";
        case "by.title":
          return "title";
        default:
          return "filter_alt";
      }
    }

    switch (filter.code) {
      case "by.id":
        return "tag";
      case "by.title":
        return "title";
      case "by.assigned":
        return "person";
      case "by.branch":
        return "business";
      case "by.department":
        return "apartment";
      case "by.registered":
        return "how_to_reg";
      case "by.status":
        return "check_circle";
      case "by.priority":
        return "priority_high";
      case "newest":
        return "new_releases";
      case "active":
        return "toggle_on";
      case "archived":
        return "archive";
      default:
        return "filter_alt";
    }
  }

  getFilterDisplayValue(filter: any): string {
    if (filter.code === "not" && filter.filters?.length) {
      const innerFilter = filter.filters[0];
      const innerLabel = this.getFilterDisplayValue(innerFilter);
      return `Niet ${innerLabel}`;
    }

    if (filter.code === "match.any" && filter.filters?.length) {
      const type = filter.filters[0]?.code;

      switch (type) {
        case "by.registered":
          return filter.filters
            .map((f: any) => this.userService.labelForId(f.id))
            .join(", ");
        case "by.assigned":
          return filter.filters
            .map((f: any) => this.userService.labelForId(f.id))
            .join(", ");
        case "by.branch":
          return filter.filters
            .map((f: any) => this.branchService.labelForId(f.id))
            .join(", ");
        case "by.department":
          return filter.filters
            .map((f: any) => this.department.labelForId(f.id))
            .join(", ");
        case "by.status":
          return filter.filters
            .map((f: any) => this.statusService.labelForId(f.id))
            .join(", ");
        case "by.priority":
          return filter.filters
            .map((f: any) => this.priority.labelForId(f.id))
            .join(", ");
        case "by.id":
          return filter.filters.map((f: any) => f.id).join(", ");
        case "by.title":
          return filter.filters.map((f: any) => f.searchphrase).join(", ");
      }
    }

    switch (filter.code) {
      case "by.id":
        return filter.id;
      case "by.title":
        return filter.searchphrase;
      case "by.assigned":
        return this.userService.labelForId(filter.id);
      case "by.branch":
        return this.branchService.labelForId(filter.id);
      case "by.department":
        return this.department.labelForId(filter.id);
      case "by.registered":
        return this.userService.labelForId(filter.id);
      case "by.status":
        return this.statusService.labelForId(filter.id);
      case "by.priority":
        return this.priority.labelForId(filter.id);
      case "newest":
        return filter.top;
      case "active":
        return filter.active;
      case "archived":
        return filter.archived;
      default:
        return filter.name || filter.code;
    }
  }
}
